import * as React from 'react';

import {Button} from 'shells/button/button';

import {CancelBookingModal} from './cancel-booking-modal';

type Props = {
    eventName: string;
    startTime: number;
    bookedByName: string;
    onCancelBooking: (optionalMessage?: string | null | undefined) => void;
};

export function CancelButton(props: Props) {
    const [isShowingModal, setIsShowingModal] = React.useState<boolean>(false);
    const [optionalMessage, setOptionalMessage] = React.useState<string>('');
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const openModal = () => setIsShowingModal(true);
    const closeModal = () => setIsShowingModal(false);

    const onCancelBooking = () => {
        setIsSaving(true);
        setTimeout(() => props.onCancelBooking(optionalMessage), 1000);
    };

    return (
        <>
            <Button onClick={openModal}>Cancel</Button>
            {isShowingModal && (
                <CancelBookingModal
                    eventName={props.eventName}
                    startTime={props.startTime}
                    bookedByName={props.bookedByName}
                    onCancelBooking={onCancelBooking}
                    onClose={closeModal}
                    isSaving={isSaving}
                    optionalMessage={optionalMessage}
                    setOptionalMessage={(text: string) => {
                        setOptionalMessage(text);
                    }}
                />
            )}
        </>
    );
}
